<template>
  <div class="LookupReport">
    <mu-tabs :value.sync="active"
             @change="tabChange"
             class="tab"
             inverse
             color="#3B9CFD"
             indicator-color="#3B9CFD"
             center>
      <mu-tab>手机号</mu-tab>
      <mu-tab>卡密用户</mu-tab>
    </mu-tabs>

    <div class="main">

      <mu-form ref="form" :model="form" v-show="active === 0 " >
        <mu-form-item label="报告人姓名" prop="name" :rules="rules.nameRules" label-float icon="account_circle">
          <mu-text-field v-model="form.name" @keyup.enter.native=onSubmit(form) ></mu-text-field>
        </mu-form-item>
        <mu-form-item label="报告人手机号" prop="phoneNo" :error-text="formPhoneError" :rules="rules.phoneRules" label-float icon="phone_iphone">
          <mu-text-field v-model="form.phoneNo" @keyup.enter.native=onSubmit(form) ></mu-text-field>
        </mu-form-item>
        <mu-form-item label="验证码" prop="verifyCode" :rules="rules.verifyRules" label-float icon="verified_user">
          <mu-text-field v-model="form.verifyCode" @keyup.enter.native=onSubmit(form) >
            <template #append>
                <mu-button round color="primary" v-if="!is_verify" @click="getVerify(form.phoneNo)" small >发送验证码</mu-button>
                <van-count-down
                    v-show="is_verify"
                    ref="countDown"
                    :time="60000"
                    :auto-start="false"
                    format="ss"
                    @finish="finish"
                />
            </template>
          </mu-text-field>
        </mu-form-item>
        <mu-form-item>
          <mu-button @click="onSubmit(form)" style="width: 100%; height: 52px;" round color="primary">确定</mu-button>
        </mu-form-item>
      </mu-form>

      <mu-form ref="CardForm" :model="CardForm" v-show="active === 1" >
        <mu-form-item label="卡号" prop="cardNo" :rules="CardRules.cardnumberRules" label-float icon="credit_card">
          <mu-text-field v-model="CardForm.cardNo" @keyup.enter.native=onSubmitCard(CardForm) ></mu-text-field>
        </mu-form-item>
        <mu-form-item label="卡密" prop="cardPassword" :rules="CardRules.passwordRules" label-float icon="lock">
          <mu-text-field v-model="CardForm.cardPassword" @keyup.enter.native=onSubmitCard(CardForm) ></mu-text-field>
        </mu-form-item>
        <mu-form-item>
          <mu-button @click="onSubmitCard(CardForm)" style="width: 100%; height: 52px;" round color="primary">确定</mu-button>
        </mu-form-item>
      </mu-form>

    </div>

  </div>
</template>

<script>
export default {
  name: "LookupReport",
  data() {
    return{
      active: 1,
      // 手机号
      form: {
        name: null,
        phoneNo: null,
        verifyCode: null
      },
      rules: {
        nameRules: [
          { validate: (val) => !!val, message: '必须填写报告人姓名'},
        ],
        phoneRules: [
          { validate: (val) => !!val, message: '必须填写报告人手机号'},
          { validate: (val) => /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/.test(val), message: "报告人手机号不正确"},
        ],
        verifyRules: [
          { validate: (val) => !!val, message: '必须填写验证码'},
        ],
      },
      is_verify: false,
      formPhoneError: null,
      // 卡密用户
      CardForm: {
        cardNo: null,
        cardPassword: null,
      },
      CardRules: {
        cardnumberRules: [
          { validate: (val) => !!val, message: '必须填写卡号'},
        ],
        passwordRules: [
          { validate: (val) => !!val, message: '必须填写卡密'},
        ],
      },
    }
  },
  created() {
    this.$isIos();

    if(!this.$store.state.token) {
      this.$auth();
    }


  },
  mounted() {

  },
  methods: {
      onSubmitCard(formName) {
        this.$refs.CardForm.validate()
          .then(res => {
            if(res) {
              console.log(formName);

              this.$post("report/verify/card",formName)
                .then(res => {
                  if(res) {
                    console.log(res);

                    this.$router.push({
                      path: "/ReportList",
                      query: {
                        orderNum: res.data
                      }
                    })

                  }
                })

            }
          })
      },
      // 获取验证码
      getVerify(e) {
        if(/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/.test(e)) {
          let obj = {};
          obj["phoneNo"]= e;
          this.$post("login/sendPhoneCode",obj)
            .then(res => {
              if(res) {
                this.is_verify= true;
                this.$refs.countDown.start();
              }
            })

        }else {
          this.formPhoneError= "请输入正确手机号";
        }
      },
      onSubmit(formName) {
        this.$refs.form.validate()
            .then((res) => {
              if(res) {
               console.log(formName);

               this.$post("report/verify/phone",formName)
                  .then(res => {
                    if(res) {
                      console.log(res);

                      let obj = {};
                      obj["name"]= formName.name;
                      obj["phoneNo"]= formName.phoneNo;

                      this.$router.push({
                        path: "/ReportList",
                        query: {
                          data: JSON.stringify(obj)
                        }
                      })
                    }
                  })

              }
            })
      },
      // 倒计时
      finish() {
        this.is_verify= false;
        this.$refs.countDown.reset();
      },
      // tab change
      tabChange(e) {
        if(e == 1) {
          this.$nextTick(()=> {
            this.$refs.CardForm.clear();
            this.form= {
              name: null,
              phone: null,
              verify: null
            }
          })
        }else {
          this.$nextTick(()=> {
            this.$refs.form.clear();
            this.CardForm= {
              cardnumber: null,
              password: null,
            }
          })
        }
      }
  }
}
</script>

<style lang="less" scoped>
  @import "../../style/Report/LookupReport";
</style>
